import { z } from "zod";

export const schema = z.object({
    id: z.string().optional(),
    pageUrl: z.string().min(1, "Page URL is required"),
    pageCondition: z.string().min(1, "Page Condition is required"),
    pageIntent: z.string().min(1, "Page Intent is required"),
});
export type schemaProps = z.infer<typeof schema>